import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Button,
  Box,
  TableBody,
  // Typography,
  Paper,
  Autocomplete,
  // FormControl,
  // Select,
  // MenuItem,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  getTaxCard,
  getTaxCodeWithDuplicate,
  getTaxCodeByTaxCardId,
  getTaxCodeByTaxCardIdForIP,
  getWHTCodeByTaxType,
  vendorTaxDetail,
  getTaxCodeWithBlock,
  getCommentsByERFInvoiceNo,
  // getTaxCodeByTaxCardIdByDefault,
} from "../../actions";
import EmptyData from "../../../../StyledComponents/Table/EmptyData";
import getParameterByName from "../../../../Functions/functions";
import "./style.css";
const useStyles = makeStyles({
  table: {
    // minWidth: 650,
    "& .MuiTableCell-root": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
      textAlign: "center",
      margin: "0px",
      padding: "4px !important",
      fontSize: "12px !important",
    },

    // tablebody: {
    //   "&.MuiTableRow-root:last-child td": {
    //     borderLeft: "1px solid #000",
    //   },
    // },
  },
  cell_purchase: {
    width: "100px",
    minWidth: 1,
  },
  cell_short: {
    width: "60px",
    minWidth: 1,
  },
  cell_ex: {
    width: "60px",
    minWidth: 1,
  },
  cell_med: {
    width: "97px",
    minWidth: 1,
  },
  cell_wide: {
    width: "220px",
    // minWidth: 1,
  },
});
const CustomPaper = (props) => {
  return (
    <Paper
      style={{ width: "150px", fontSize: "12px" }}
      elevation={8}
      {...props}
    />
  );
};
function TaxTable({
  formState,
  setFormState,
  invoice_Amount,
  invoicePayload,
  show,
  edit,
  isProceed,
  setTaxErrorMsg,
  taxErrorMsg,
}) {
  const [commentsList, setCommentsList] = useState([]);
  const [, setCommentsLoading] = useState(false);

  useEffect(()=>{
  getCommentsByERFInvoiceNo(
    setCommentsList,
    setCommentsLoading,
    formState?.invoice_No
  );
},[])
  const tableData = {
    invoice_Id: invoicePayload?.Invoice_id || 0,
    category: "",
    purchaseType: "",
    supplierJurisdiction: "",
    supplierType: "",
    status: "",
    fillingStatus: "",
    goodsNature: "",
    taxType: "",
    taxCode: "",
    amount: invoice_Amount,

    //   // <<<<===earlier====>  //
    //   // taxId: 0,
    //   // invoice_Id: parseInt(invoicePayload?.Invoice_id) || 0,
    //   // taxType: "",
    //   // taxCode: "",
    //   // amount: invoice_Amount || "",
    //   // comments: "",
    //   // created_By: "",
    //   // created_On: new Date(),
    //   // updated_By: "",
    //   // updated_On: new Date(),
    //   // taxCardId: 0,

    //   // category: "",
    //   // purchaseType: "",
    //   // supplierJurisdiction: "",
    //   // supplierType: "",
    //   // status: "",
    //   // fillingStatus: "",
    //   // goodsNature: "",
  };

  const classes = useStyles();
  const [taxTableDropdownData, setTaxTableDropdownData] = useState({
    category: [],
    purchaseType: [],
    supplierJurisdiction: [],
    supplierType: [],
    status: [],
    fillingStatus: [],
    goodsNature: [],
    taxType: [],
    taxCode: [],
  });
  const status = getParameterByName("status");
  const roleName = getParameterByName("roleName");

  const [taxCardLoading, setTaxCardLoading] = useState(false);
  const [taxCardData, setTaxCardData] = useState([]);
  const [taxCodeList, setTaxCodeList] = useState([]);
  const [taxCodeListLoading, setTaxCodeListLoading] = useState(true);
  // const [taxErrorMsg, setTaxErrorMsg] = useState("");
  const addInput = () => {
    setFormState((formState) => ({
      ...formState,
      taxCard_List: [
        ...(formState.taxCard_List || []),
        formState.taxCard_List[formState.taxCard_List.length - 1],
      ],
    }));
  };

  const deleteInput = (index) => {
    const filteredData = formState?.taxCard_List?.filter((x, i) => i !== index);
    if (filteredData.length === 0) {
      filteredData[0] = tableData;
    }
    setFormState((formState) => ({
      ...formState,
      taxCard_List: filteredData,
    }));

    setTaxErrorMsg("");
  };

  const changeHandler = (e, index) => {
    const { name, value } = e.target;
    let tempArray = formState.taxCard_List;
    // if(name === "amount"){
    //   tempArray[index] = {
    //     ...formState.taxCard_List[index],
    //     [name]:  Number(value)?.toFixed(2),
    //   };
    // }
    tempArray[index] = {
      ...formState.taxCard_List[index],
      [name]: value,
    };
    setFormState((formState) => ({
      ...formState,
      taxCard_List: tempArray,
    }));
  };

  useEffect(() => {
    getTaxCard(setTaxTableDropdownData, setTaxCardLoading, setTaxCardData);
    getTaxCodeWithBlock(setTaxCodeList, setTaxCodeListLoading);
    // getTaxCodeWithDuplicate(setTaxCodeList, setTaxCodeListLoading);

    if (edit == "true") {
      vendorTaxDetail(
        setTaxTableDropdownData,
        setFormState,
        formState,
        invoicePayload?.Vendor_Code,
        invoicePayload?.Invoice_id,
        invoice_Amount,
        setTaxCardLoading
      );
    }
  }, []);

  const getBindingsOfTaxTable = (f, bindingNames, tempArray, index) => {
    for (let i = f?.id || 0; i < bindingNames.length; i++) {
      const element = bindingNames[i];
      const updated = tempArray[index];
      const filtered = taxCardData.filter((x) => {
        if (
          updated?.category &&
          updated?.purchaseType &&
          updated?.supplierJurisdiction &&
          updated?.supplierType &&
          updated?.status &&
          updated?.fillingStatus &&
          updated?.goodsNature
        ) {
          return (
            updated?.category === x?.category &&
            updated?.purchaseType === x?.purchaseType &&
            updated?.supplierJurisdiction === x?.supplierJurisdiction &&
            updated?.supplierType === x?.supplierType &&
            updated?.status === x?.status &&
            updated?.fillingStatus === x?.fillingStatus &&
            updated?.goodsNature === x?.goodsNature
          );
        } else if (
          updated?.category &&
          updated?.purchaseType &&
          updated?.supplierJurisdiction &&
          updated?.supplierType &&
          updated?.status &&
          updated?.fillingStatus
        ) {
          return (
            updated?.category === x?.category &&
            updated?.purchaseType === x?.purchaseType &&
            updated?.supplierJurisdiction === x?.supplierJurisdiction &&
            updated?.supplierType === x?.supplierType &&
            updated?.status === x?.status &&
            updated?.fillingStatus === x?.fillingStatus
          );
        } else if (
          updated?.category &&
          updated?.purchaseType &&
          updated?.supplierJurisdiction &&
          updated?.supplierType &&
          updated?.status
        ) {
          return (
            updated?.category === x?.category &&
            updated?.purchaseType === x?.purchaseType &&
            updated?.supplierJurisdiction === x?.supplierJurisdiction &&
            updated?.supplierType === x?.supplierType &&
            updated?.status === x?.status
          );
        } else if (
          updated?.category &&
          updated?.purchaseType &&
          updated?.supplierJurisdiction &&
          updated?.supplierType
        ) {
          return (
            updated?.category === x?.category &&
            updated?.purchaseType === x?.purchaseType &&
            updated?.supplierJurisdiction === x?.supplierJurisdiction &&
            updated?.supplierType === x?.supplierType
          );
        } else if (
          updated?.category &&
          updated?.purchaseType &&
          updated?.supplierJurisdiction
        ) {
          return (
            updated?.category === x?.category &&
            updated?.purchaseType === x?.purchaseType &&
            updated?.supplierJurisdiction === x?.supplierJurisdiction
          );
        } else if (updated?.category && updated?.purchaseType) {
          return (
            updated?.category === x?.category &&
            updated?.purchaseType === x?.purchaseType
          );
        } else if (updated?.category) {
          return updated?.category === x?.category;
        } else {
          return x;
        }
      });
      let binding = [
        ...new Map(filtered.map((item) => [item[element.name], item])).values(),
      ];
      setTaxTableDropdownData((taxTableDropdownData) => ({
        ...taxTableDropdownData,
        [element.name]: binding,
      }));

      let newValue = "";
      if (
        element?.name === "status" &&
        updated?.supplierType === "Unregistered"
      ) {
        //if statement, if supplierType is Unregistered and set value for status
        if (binding[0][element?.name] === "Active / Non-Active") {
          newValue = binding[0][element?.name];
        } else {
          newValue = "Non-Active";
        }
      } else if (
        element?.name === "fillingStatus" &&
        updated?.supplierType === "Unregistered"
      ) {
        // 2nd if statement, if supplierType is Unregistered and set value for fillingStatus
        newValue = "Non- Filer";
      } else {
        newValue = binding?.[0]?.[element?.name] || "";
      }

      tempArray[index] = {
        ...formState.taxCard_List[index],
        [element.name]:
          f !== null
            ? // newValue
              element?.name === "status" &&
              updated?.supplierType === "Unregistered" //if statement, if supplierType is Unregistered and set value for status.
              ? binding[0][element?.name] === "Active / Non-Active"
                ? binding[0][element?.name]
                : "Non-Active"
              : element?.name === "fillingStatus" &&
                updated?.supplierType === "Unregistered" // 2nd if statement, if supplierType is Unregistered and set value for fillingStatus.
              ? updated?.category === "Company"
                ? "Non-Filer"
                : "Non- Filer"
              : binding?.[0]?.[element?.name]
            : "",
        dropdowns: {
          ...formState.taxCard_List[index].dropdowns,
          [element.name]: binding,
        },
      };
    }
    return tempArray;
  };

  const autoCompleteChangeHandler = (
    name,
    newValue,
    index,
    nextBindingName
  ) => {
    let tempArray = formState.taxCard_List;
    tempArray[index] = {
      ...formState.taxCard_List[index],
      [name]:
        name === "taxType"
          ? newValue?.taxType
          : name === "taxCode"
          ? newValue?.taxCode
          : newValue?.[name],
    };

    // As discused in meeting with hamza (to remove this api because this functionality is not avalible at i2p 1.0);
    //  As discused in meetng with hamza it is only for ip page

    // if (roleName === "IP" && name === "taxType") {
    //   getWHTCodeByTaxType(
    //     setTaxTableDropdownData,
    //     setFormState,
    //     formState,
    //     tempArray,
    //     index,
    //     newValue?.taxType,
    //     formState?.salesTaxCode
    //   );
    // }

    setFormState((formState) => ({
      ...formState,
      taxCard_List: tempArray,
    }));

    if (
      name === "category" ||
      name === "purchaseType" ||
      name === "supplierJurisdiction" ||
      name === "supplierType" ||
      name === "status" ||
      name === "fillingStatus" ||
      name === "goodsNature"
    ) {
      tempArray[index] = {
        ...formState.taxCard_List[index],
        [name]: newValue?.[name],
        taxType: "",
        taxCode: "",
        // amount: tempArray[index].amount || invoice_Amount,
        purchaseType: name === "category" ? "" : tempArray[index].purchaseType,
        supplierJurisdiction:
          name === "category" || name === "purchaseType"
            ? ""
            : tempArray[index].supplierJurisdiction,
        supplierType:
          name === "category" ||
          name === "purchaseType" ||
          name === "supplierJurisdiction"
            ? ""
            : tempArray[index].supplierType,
        status:
          name === "category" ||
          name === "purchaseType" ||
          name === "supplierJurisdiction" ||
          name === "supplierType"
            ? ""
            : tempArray[index].status,
        fillingStatus:
          name === "category" ||
          name === "purchaseType" ||
          name === "supplierJurisdiction" ||
          name === "supplierType" ||
          name === "status"
            ? ""
            : tempArray[index].fillingStatus,
        goodsNature:
          name === "category" ||
          name === "purchaseType" ||
          name === "supplierJurisdiction" ||
          name === "supplierType" ||
          name === "status" ||
          name === "fillingStatus"
            ? ""
            : tempArray[index].goodsNature,
      };

      const bindingNames = [
        { id: 1, name: "purchaseType" },
        { id: 2, name: "supplierJurisdiction" },
        { id: 3, name: "supplierType" },
        { id: 4, name: "status" },
        { id: 5, name: "fillingStatus" },
        { id: 6, name: "goodsNature" },
      ];
      const f = bindingNames.find((x) => x.name === name);

      tempArray = getBindingsOfTaxTable(f, bindingNames, tempArray, index);

      // Block tax code (check)
      const _category = tempArray[index].category
        ? tempArray[index].category
        : "";
      const _purchaseType = tempArray[index].purchaseType
        ? tempArray[index].purchaseType
        : "";
      const _supplierJurisdiction = tempArray[index].supplierJurisdiction
        ? tempArray[index].supplierJurisdiction
        : "";
      const _supplierType = tempArray[index].supplierType
        ? tempArray[index].supplierType
        : "";
      const _status = tempArray[index].status ? tempArray[index].status : "";
      const _fillingStatus = tempArray[index].fillingStatus
        ? tempArray[index].fillingStatus
        : "";
      const _goodsNature = tempArray[index].goodsNature
        ? tempArray[index].goodsNature
        : "";
      const _d = taxCardData.filter(
        (i) =>
          (i.category === _category || _category === "") &&
          (i.purchaseType === _purchaseType || _purchaseType === "") &&
          (i.supplierJurisdiction === _supplierJurisdiction ||
            _supplierJurisdiction === "") &&
          (i.supplierType === _supplierType || _supplierType === "") &&
          (i.status === _status || _status === "") &&
          (i.fillingStatus === _fillingStatus || _fillingStatus === "") &&
          (i.goodsNature === _goodsNature || _goodsNature === "")
      );
      if (_d.length > 0) {
        var _t = taxCodeList.filter(
          (i) => i.TaxCardIds.split(",").indexOf(_d[0].id.toString()) > -1
        );
        // var _taxType = app.taxType_list.filter(i => app.taxCodes.filter(i => i.TaxCardIds != undefined && i.TaxCardIds != '').filter(i => i.TaxCardIds.split(',').filter(i => _d.map(j => j.Id.toString()).includes(i))).map(i => i.WH_TAX_TYPE).includes(i.substring(0,2)))
        var _taxType = formState?.vendor_tax_detail?.filter((i) =>
          _t?.map((j) => j?.WHTaxType)?.includes(i?.Tax_Type)
        );
        if (_taxType.length > 0) {
          setTaxErrorMsg("");
        } else {
          setTaxErrorMsg("Tax Codes are not available with current selection.");
        }
      } else {
        setTaxErrorMsg("Tax Codes are not available with current selection.");
      }
      // <<<=====Block tax code (check)=====>>>

      const finded = taxCardData.find(
        (x) =>
          x.category === tempArray[index].category &&
          x.purchaseType === tempArray[index].purchaseType &&
          x.supplierJurisdiction === tempArray[index].supplierJurisdiction &&
          x.supplierType === tempArray[index].supplierType &&
          x.status === tempArray[index].status &&
          x.fillingStatus === tempArray[index].fillingStatus &&
          x.goodsNature === tempArray[index].goodsNature
      );
      setFormState((formState) => ({
        ...formState,
        taxCard_List: tempArray,
      }));
      if (roleName !== "IP") {
        getTaxCodeByTaxCardId(
          setTaxTableDropdownData,
          setFormState,
          formState,
          tempArray,
          index,
          finded?.id,
          invoicePayload?.Invoice_id,
          invoice_Amount
        );
      } else {
        getTaxCodeByTaxCardIdForIP(
          setTaxTableDropdownData,
          setFormState,
          formState,
          tempArray,
          index,
          finded?.id,
          invoicePayload?.Invoice_id,
          invoice_Amount
        );
      }
    }
  };

  // if vender have already some tax detail.
  const getBindingsOfTaxTableForVendorTaxDetail = (
    bindingNames,
    tempArray,
    index
  ) => {
    for (let i = 0; i < bindingNames.length; i++) {
      const bindingName = bindingNames[i];
      const updated = tempArray[index];

      const filtered = taxCardData.filter((x) => {
        if (bindingName.name === "category") {
          return x;
        } else if (bindingName.name === "purchaseType") {
          return updated?.category === x?.category;
        } else if (bindingName.name === "supplierJurisdiction") {
          return (
            updated?.category === x?.category &&
            updated?.purchaseType === x?.purchaseType
          );
        } else if (bindingName.name === "supplierType") {
          return (
            updated?.category === x?.category &&
            updated?.purchaseType === x?.purchaseType &&
            updated?.supplierJurisdiction === x?.supplierJurisdiction
          );
        } else if (bindingName.name === "status") {
          return (
            updated?.category === x?.category &&
            updated?.purchaseType === x?.purchaseType &&
            updated?.supplierJurisdiction === x?.supplierJurisdiction &&
            updated?.supplierType === x?.supplierType
          );
        } else if (bindingName.name === "fillingStatus") {
          return (
            updated?.category === x?.category &&
            updated?.purchaseType === x?.purchaseType &&
            updated?.supplierJurisdiction === x?.supplierJurisdiction &&
            updated?.supplierType === x?.supplierType &&
            updated?.status === x?.status
          );
        } else if (bindingName.name === "goodsNature") {
          return (
            updated?.category === x?.category &&
            updated?.purchaseType === x?.purchaseType &&
            updated?.supplierJurisdiction === x?.supplierJurisdiction &&
            updated?.supplierType === x?.supplierType &&
            updated?.status === x?.status &&
            updated?.fillingStatus === x?.fillingStatus
          );
        }
      });

      let binding = [
        ...new Map(
          filtered.map((item) => [item[bindingName.name], item])
        ).values(),
      ];
      setTaxTableDropdownData((taxTableDropdownData) => ({
        ...taxTableDropdownData,
        [bindingName.name]: binding,
      }));
      tempArray[index] = {
        ...formState.taxCard_List[index],
        // [bindingName.name]: binding[0][bindingName?.name],
        dropdowns: {
          ...formState.taxCard_List[index]?.dropdowns,
          [bindingName.name]: binding,
        },
      };
    }
   const allKeys = tempArray.reduce((acc, item) => {
  const keys = Object.keys(item);
  if (acc.length === 0) return keys;
  return acc.filter((key) => keys.includes(key));
}, []);

tempArray = tempArray.filter((item) =>
  allKeys.every((key) => item.hasOwnProperty(key))
);
    return tempArray;
  };

  const getBindingsOfTaxTypeAndWHTCode = (tempArray) => {
    for (let index = 0; index < formState.taxCard_List.length; index++) {
      const finded = taxCardData.find(
        (x) =>
          x.category === tempArray[index]?.category &&
          x.purchaseType === tempArray[index].purchaseType &&
          x.supplierJurisdiction === tempArray[index].supplierJurisdiction &&
          x.supplierType === tempArray[index].supplierType &&
          x.status === tempArray[index].status &&
          x.fillingStatus === tempArray[index].fillingStatus &&
          x.goodsNature === tempArray[index].goodsNature
      );
      if (roleName !== "IP") {
        getTaxCodeByTaxCardId(
          setTaxTableDropdownData,
          setFormState,
          formState,
          tempArray,
          index,
          finded?.id,
          invoicePayload?.Invoice_id,
          invoice_Amount
        );
      } else {
        getTaxCodeByTaxCardIdForIP(
          setTaxTableDropdownData,
          setFormState,
          formState,
          tempArray,
          index,
          finded?.id,
          invoicePayload?.Invoice_id,
          invoice_Amount
        );
      }
    }
  };

 useEffect(() => {
  let tempArray = formState.taxCard_List;
  const bindingNames = [
    { id: 1, name: "category" },
    { id: 2, name: "purchaseType" },
    { id: 3, name: "supplierJurisdiction" },
    { id: 4, name: "supplierType" },
    { id: 5, name: "status" },
    { id: 6, name: "fillingStatus" },
    { id: 7, name: "goodsNature" },
  ];

  if (formState?.taxCard_ListCheck?.length === 0) {
    // const f = bindingNames.find((x) => x.name === name);
    const index = 0;
    tempArray[index] = tableData;

    tempArray = getBindingsOfTaxTable(null, bindingNames, tempArray, index);
    const finded = taxCardData.find(
      (x) =>
        x.category === tempArray[index].category &&
        x.purchaseType === tempArray[index].purchaseType &&
        x.supplierJurisdiction === tempArray[index].supplierJurisdiction &&
        x.supplierType === tempArray[index].supplierType &&
        x.status === tempArray[index].status &&
        x.fillingStatus === tempArray[index].fillingStatus &&
        x.goodsNature === tempArray[index].goodsNature
    );

    setFormState((formState) => ({
      ...formState,
      taxCard_List: tempArray,
    }));
    if (roleName !== "IP") {
      getTaxCodeByTaxCardId(
        setTaxTableDropdownData,
        setFormState,
        formState,
        tempArray,
        index,
        finded?.id,
        invoicePayload?.Invoice_id,
        invoice_Amount
      );
    } else {
      getTaxCodeByTaxCardIdForIP(
        setTaxTableDropdownData,
        setFormState,
        formState,
        tempArray,
        index,
        finded?.id,
        invoicePayload?.Invoice_id,
        invoice_Amount
      );
    }
  } else if (formState?.taxCard_ListCheck?.length > 0) {
    for (let i = 0; i < formState?.taxCard_ListCheck?.length; i++) {
      tempArray = getBindingsOfTaxTableForVendorTaxDetail(
        bindingNames,
        tempArray,
        i
      );
    }
    setFormState((formState) => ({
      ...formState,
      taxCard_List: tempArray,
    }));
    getBindingsOfTaxTypeAndWHTCode(tempArray);
  }
}, [formState?.taxCard_ListCheck]);

  return (
    <div>
      <Grid container>
        <h3 style={{ color: "red" }}>{taxErrorMsg ? taxErrorMsg : ""}</h3>

        <Grid item xs={12} sm={12} md={12} lg={12} style={{ width: "0" }}>
          <TableContainer className="scrollable">
            <Table
              className={classes.table}
              aria-label="a dense table"
              // sx={{
              //   width: "max-content"
              // }}
              size="small"
            >
              <TableHead>
                <TableRow sx={{ backgroundColor: "#EFF2F4", fontSize: "11" }}>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                    Category
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                    Purchase Type
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                    Supplier Jurisdiction
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                    Supplier Type
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                    Status
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031c30" }}>
                    Filling Status
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031c30" }}>
                    Goods Nature
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031c30" }}>
                    Tax Type
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031c30" }}>
                    WHT Code
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#031c30" }}>
                    Base Amount
                  </TableCell>
                  {edit == "false" || !edit ? (
                    ""
                  ) : (
                    <TableCell
                      style={{
                        textAlign: "center",
                        fontWeight: "bold",
                        color: "#031c30",
                      }}
                    >
                      Action
                    </TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {formState?.taxCard_List?.map((item, index) => {
                  return (
                    <TableRow
                      key={index}
                      // sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell
                        scope="row"
                        className={classes.cell_med}
                        sx={{ padding: "8px" }}
                      >
                        <Autocomplete
                          id="selectedTaxCode"
                          style={{ width: "inherit", display: "inline-block" }}
                          // options={item?.dropdowns?.category || []}
                          options={taxTableDropdownData?.category}
                          size="small"
                          // style={{ width: 200}}
                          // value={taxTableDropdownSelected.category}
                          value={{ category: item?.category || "" }}
                          getOptionLabel={(option) =>
                            (option !== "" && `${option?.category}`) || ""
                          }
                          // key={(option) => option?.category}
                          loading={taxCardLoading}
                          variant="standard"
                          onChange={(event, newValue) => {
                            autoCompleteChangeHandler(
                              "category",
                              newValue,
                              index,
                              "purchaseType"
                            );
                          }}
                          PaperComponent={CustomPaper}
                          freeSolo
                          disabled={edit == "false" || !edit ? true : false}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              type="text"
                              style={{
                                overflow: "hidden",
                              }}
                              name=""
                              variant="standard"
                              required={isProceed}
                            />
                          )}
                        />
                      </TableCell>
                      <TableCell
                        sx={{ padding: "8px" }}
                        className={classes.cell_purchase}
                      >
                        <Autocomplete
                          id=""
                          style={{ width: "inherit", display: "inline-block" }}
                          // options={taxTableDropdownData?.purchaseType}
                          options={item?.dropdowns?.purchaseType || []}
                          size="small"
                          value={{ purchaseType: item?.purchaseType || "" }}
                          getOptionLabel={(option) =>
                            (option !== "" && `${option?.purchaseType}`) || ""
                          }
                          key={(option) => option?.purchaseType}
                          loading={taxCardLoading}
                          variant="standard"
                          PaperComponent={CustomPaper}
                          onChange={(event, newValue) => {
                            autoCompleteChangeHandler(
                              "purchaseType",
                              newValue,
                              index,
                              "supplierJurisdiction"
                            );
                          }}
                          disabled={edit == "false" || !edit ? true : false}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              type="text"
                              name=""
                              variant="standard"
                              style={{ overflow: "hidden" }}
                              required={item?.category && item?.taxCode}
                            />
                          )}
                        />
                      </TableCell>

                      <TableCell
                        sx={{ padding: "8px" }}
                        className={classes.cell_med}
                      >
                        <Autocomplete
                          id=""
                          // options={taxTableDropdownData?.supplierJurisdiction}
                          options={item?.dropdowns?.supplierJurisdiction || []}
                          size="small"
                          style={{ width: "inherit", display: "inline-block" }}
                          value={{
                            supplierJurisdiction:
                              item?.supplierJurisdiction || "",
                          }}
                          getOptionLabel={(option) =>
                            (option !== "" &&
                              `${option?.supplierJurisdiction}`) ||
                            ""
                          }
                          key={(option) => option?.supplierJurisdiction}
                          loading={taxCardLoading}
                          variant="standard"
                          onChange={(event, newValue) => {
                            autoCompleteChangeHandler(
                              "supplierJurisdiction",
                              newValue,
                              index,
                              "supplierType"
                            );
                          }}
                          disabled={edit == "false" || !edit ? true : false}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              type="text"
                              name=""
                              variant="standard"
                              style={{ overflow: "hidden" }}
                              required={item?.category && item?.taxCode}
                            />
                          )}
                        />
                      </TableCell>
                      <TableCell
                        sx={{ padding: "8px" }}
                        className={classes.cell_short}
                      >
                        <Autocomplete
                          id=""
                          // options={taxTableDropdownData?.supplierType}
                          options={item?.dropdowns?.supplierType || []}
                          size="small"
                          style={{ width: "inherit", display: "inline-block" }}
                          value={{ supplierType: item?.supplierType || "" }}
                          getOptionLabel={(option) =>
                            (option !== "" && `${option?.supplierType}`) || ""
                          }
                          key={(option) => option?.supplierType}
                          loading={taxCardLoading}
                          variant="standard"
                          PaperComponent={CustomPaper}
                          onChange={(event, newValue) => {
                            autoCompleteChangeHandler(
                              "supplierType",
                              newValue,
                              index,
                              "status"
                            );
                          }}
                          disabled={edit == "false" || !edit ? true : false}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              type="text"
                              name=""
                              variant="standard"
                              style={{ overflow: "hidden" }}
                              required={item?.category && item?.taxCode}
                            />
                          )}
                        />
                      </TableCell>

                      <TableCell
                        sx={{ padding: "8px" }}
                        className={classes.cell_short}
                      >
                        <Autocomplete
                          id=""
                          // options={taxTableDropdownData?.status}
                          options={item?.dropdowns?.status || []}
                          size="small"
                          style={{ width: "inherit", display: "inline-block" }}
                          value={{ status: item?.status || "" }}
                          getOptionLabel={(option) =>
                            (option !== "" && `${option?.status}`) || ""
                          }
                          key={(option) => option?.status}
                          loading={taxCardLoading}
                          variant="standard"
                          PaperComponent={CustomPaper}
                          onChange={(event, newValue) => {
                            autoCompleteChangeHandler(
                              "status",
                              newValue,
                              index,
                              "fillingStatus"
                            );
                          }}
                          disabled={edit == "false" || !edit ? true : false}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              type="text"
                              name=""
                              variant="standard"
                              style={{ overflow: "hidden" }}
                              required={item?.category && item?.taxCode}
                            />
                          )}
                        />
                      </TableCell>
                      <TableCell
                        sx={{ padding: "8px" }}
                        className={classes.cell_short}
                      >
                        <Autocomplete
                          id=""
                          // options={taxTableDropdownData?.fillingStatus}
                          options={item?.dropdowns?.fillingStatus || []}
                          size="small"
                          style={{ width: "inherit", display: "inline-block" }}
                          value={{ fillingStatus: item?.fillingStatus || "" }}
                          getOptionLabel={(option) =>
                            (option !== "" && `${option?.fillingStatus}`) || ""
                          }
                          key={(option) => option?.fillingStatus}
                          loading={taxCardLoading}
                          variant="standard"
                          PaperComponent={CustomPaper}
                          onChange={(event, newValue) => {
                            autoCompleteChangeHandler(
                              "fillingStatus",
                              newValue,
                              index,
                              "goodsNature"
                            );
                          }}
                          disabled={edit == "false" || !edit ? true : false}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              type="text"
                              name=""
                              variant="standard"
                              style={{ overflow: "hidden" }}
                              required={item?.category && item?.taxCode}
                            />
                          )}
                        />
                      </TableCell>

                      <TableCell
                        sx={{ padding: "8px" }}
                        className={classes.cell_med}
                      >
                        <Autocomplete
                          id=""
                          // options={taxTableDropdownData?.goodsNature}
                          options={item?.dropdowns?.goodsNature || []}
                          size="small"
                          style={{ width: "inherit", display: "inline-block" }}
                          value={{ goodsNature: item?.goodsNature || "" }}
                          getOptionLabel={(option) =>
                            (option !== "" && `${option?.goodsNature}`) || ""
                          }
                          key={(option) => option?.goodsNature}
                          loading={taxCardLoading}
                          variant="standard"
                          PaperComponent={CustomPaper}
                          onChange={(event, newValue) => {
                            autoCompleteChangeHandler(
                              "goodsNature",
                              newValue,
                              index,
                              ""
                            );
                          }}
                          disabled={edit == "false" || !edit ? true : false}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              type="text"
                              name=""
                              style={{ overflow: "hidden" }}
                              variant="standard"
                              // required
                              required={item?.category && item?.taxCode}
                            />
                          )}
                        />
                      </TableCell>
                      <TableCell
                        // sx={{ padding: "10px" }}
                        className={classes.cell_wide}
                      >
                        <Autocomplete
                          id="selectedTaxCode"
                          // style={{ width: "inherit", display: "inline-block" }}
                          // options={taxTableDropdownData?.taxType}
                          options={item?.dropdowns?.taxType || []}
                          size="small"
                          value={{
                            taxType: item?.taxType || "",
                            taxType_v1:
                              item?.dropdowns?.taxType?.find(
                                (x) => x?.taxType == item?.taxType
                              )?.taxType_v1 || "",
                          }}
                          PaperComponent={CustomPaper}
                          getOptionLabel={(option) =>
                            (option !== "" &&
                              `${option?.taxType_v1 || option?.taxType}`) ||
                            ""
                          }
                          // key={(option) => option?.taxType}
                          loading={taxCardLoading}
                          variant="standard"
                          onChange={(event, newValue) => {
                            autoCompleteChangeHandler(
                              "taxType",
                              newValue,
                              index
                            );
                          }}
                          disabled={edit == "false" || !edit ? true : false}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              type="text"
                              name=""
                              variant="standard"
                              required={isProceed}
                              style={{ overflow: "hidden" }}
                              // required={item?.category && item?.taxCode}
                            />
                          )}
                        />
                      </TableCell>
                      <TableCell
                        // sx={{ padding: "10px" }}
                        className={classes.cell_wide}
                      >
                        <Autocomplete
                          id=""
                          // options={taxTableDropdownData?.taxCode}
                          options={item?.dropdowns?.taxCode || []}
                          size="small"
                          // style={{ width: "inherit", display: "inline-block" }}
                          PaperComponent={CustomPaper}
                          value={{
                            taxCode: item?.taxCode || "",
                            taxCode_1:
                              item?.dropdowns?.taxCode?.find(
                                (x) => x?.taxCode == item?.taxCode
                              )?.taxCode_1 || "",
                          }}
                          getOptionLabel={(option) =>
                            (option !== "" &&
                              `${option?.taxCode_1 || option?.taxCode}`) ||
                            ""
                          }
                          // key={(option) => option?.taxCode_v1}
                          loading={taxCardLoading}
                          variant="standard"
                          onChange={(event, newValue) => {
                            autoCompleteChangeHandler(
                              "taxCode",
                              newValue,
                              index
                            );
                          }}
                          disabled={edit == "false" || !edit ? true : false}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              type="text"
                              name=""
                              variant="standard"
                              style={{ overflow: "hidden" }}
                              required={isProceed}
                            />
                          )}
                        />
                      </TableCell>
                      <TableCell
                        className={classes.cell_ex}
                        sx={{ padding: "8px" }}
                      >
                        <TextField
                          type="number"
                          size="small"
                          style={{ overflow: "hidden", width: "inherit" }}
                          sx={{
                            "& legend": { display: "none" },
                            "& fieldset": { top: 0 },
                          }}
                          variant="standard"
                          name="amount"
                          value={item?.amount}
                          onChange={(event) => changeHandler(event, index)}
                          disabled={edit == "false" || !edit ? true : false}
                        />
                      </TableCell>
                      {edit == "false" || !edit ? (
                        ""
                      ) : (
                        <TableCell align="center" className={classes.cell_ex}>
                          <DeleteIcon
                            color="error"
                            onClick={() => {
                              deleteInput(index);
                            }}
                          />
                        </TableCell>
                      )}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
            {formState?.taxCard_List?.length === 0 ||
            formState?.taxCard_List === undefined ? (
              <EmptyData />
            ) : (
              ""
            )}
          </TableContainer>
          {(!show && status !== "SendToIPFromSupervisor" )||
        commentsList[commentsList?.length-1]?.ActivityName!=="Tax Team" &&  (
            <Box display="flex" justifyContent={"flex-end"} mt={2}>
              <Button color="secondary" variant="contained" onClick={addInput}>
                Add New Row
              </Button>
            </Box>
          )}
        </Grid>
      </Grid>
    </div>
  );
}

export default TaxTable;
